<template>    
  <!---群組信息-->
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <!-- 主表单区域 -->
      <a-form-model ref="form" :model="model"  :label-col="labelCol2" :wrapper-col="wrapperCol2"  :rules="validatorRules" slot="detail">
        <a-row>
          <a-col :span="12">
            <a-form-model-item :label="this.language['cs.seatgroup.sgroupcode']"  prop="sgroupcode">
              <a-input v-model="model.sgroupcode" :placeholder="this.language['common.autosystemcode']"  disabled></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :label="this.language['cs.seatgroup.sgroupname']"  prop="sgroupname">
              <a-input v-model="model.sgroupname" :placeholder="this.language['cs.seatgroup.sgroupname']" maxLength="50"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="12"  v-show="isShow">
              <a-form-model-item :label="this.language['cs.activity.activityname']"  prop="sysactivityid">
                <a-Select @change="handChangeActivity" v-model="model.sysactivityid" :options="selectActivityList" allow-clear  show-search optionFilterProp="children" 
               :placeholder="this.language['cs.activity.activityname']"  >
              </a-Select>
              </a-form-model-item>
            </a-col>
            <a-col :span="12"  v-show="isShow">
              <a-form-model-item :label="this.language['cs.venue.venuename']"  prop="sysvenueid">
                <a-Select  v-model="model.sysvenueid" :options="selectVenueList" allow-clear  show-search optionFilterProp="children" 
               :placeholder="this.language['cs.venue.venuename']"  >
              </a-Select>
              </a-form-model-item>
            </a-col>
            <!-- <a-col :span="12">
              <a-form-model-item :label="this.language['cs.persongroup.pgroupname']"  prop="syspgoupids">
                <a-Select mode="multiple" v-model="model.syspgoupids" :options="selectPgList" allow-clear  show-search optionFilterProp="children" 
               :placeholder="this.language['cs.persongroup.pgroupname']"  >
              </a-Select>
              </a-form-model-item>
            </a-col> -->
            <a-col :span="12">
            <a-form-model-item :label="this.language['cs.seatgroup.sgroupcolor']"  prop="sgroupcolor">
        
            <a-space><p>选择的颜色：{{ color }}</p><div :style="{background:color,height:'20px',width:'30px'}"></div>
              
              <!-- <a-button @click="SelectColor">{{ buttonText }}</a-button>-->
           
              </a-space> 
              <sketch-picker v-model="model.sgroupcolor" :preset-colors="presetColors" @input="colorValueChange1" color-format="hex"></sketch-picker>
              <!-- <div class="color" >
                <div>
                  <sketch-picker v-model="model.colors" :preset-colors="presetColors" @input="colorValueChange1" color-format="hex"/>
               </div>
              
            </div> -->
  
          </a-form-model-item>
            </a-col>
          
        </a-row>
      </a-form-model>
    </j-form-container>
      <!-- 子表单区域 -->
  </a-spin>
</template>

<script>

  import { httpAction, getAction } from '@/api/manageChooseSeat'
  import { getDictItemsFromCache } from '@/api/api'
  import { FormTypes,getRefPromise,VALIDATE_NO_PASSED } from '@/utils/JEditableTableUtil'
  import { JEditableTableModelMixin } from '@/views/chooseSeat/mixins/JEditableTableModelMixin'
  import { validateDuplicateValue } from '@/utils/util'
  //import {Sketch} from 'vue-color'
  
  export default {
    name: 'SeatGroupForm',
    mixins: [JEditableTableModelMixin],
    inject:['operation','dataActivity'],
    components: {
        "sketch-picker": Sketch,
        
    },
    data() {
      return {
         // form 一行布局
      labelCol1: { span: 4 },
      wrapperCol1: { span: 18 },
      // form 两行布局， 默认为两行
      labelCol2: { span: 8 },
      wrapperCol2: { span: 12 },
        model:{ 
            sgroupcolor:"",
            colors: {
                color: "",
                hex: "#194d33",
                hsl: { h: 150, s: 0.5, l: 0.2, a: 1 },
                hsv: { h: 150, s: 0.66, v: 0.3, a: 1 },
                rgba: { r: 25, g: 77, b: 51, a: 1 },
                a: 1,
            },
        },
     
        url: {
          add: "/SeatGroup/addData",
          edit: "/SeatGroup/editData",
          detailList: '/SeatGroup/queryByDetailList'
        },
        selectActivityList:[],
        selectPgList:[],
        selectVenueList:[],
        isShowColor:false,
        isShow:true,
        buttonText:"选择颜色",
     
    presetColors: [ // 传递给vue-color的默认颜色
            '#EC0000', '#FC8C00', '#00AB44'
          ]
   
      }
    },
    props: {
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    computed: {
      language() {
      return this.$store.getters.language
    },
    formDisabled() {
      return this.disabled
    },
   
    validatorRules() {
      if (this.language) {
        return {
          sgroupname: [
            {required: true, message: this.language['cs.input']+this.language['cs.seatgroup.sgroupname']+'!'}
          ],
         
          sysactivityid: [
              {required: true, message: this.language['cs.select']+this.language['cs.activity.activityname']+'!'}
            ],
            // syspgoupids: [
            //   {required: true, message: this.language['cs.select']+this.language['cs.persongroup.pgroupname']+'!'}
            // ],
            sysvenueid: [
              {required: true, message: this.language['cs.select']+this.language['cs.venue.venuename']+'!'}
            ],
            sgroupcolor: [
              {required: true, message: this.language['cs.select']+this.language['cs.seatgroup.sgroupcolor']+'!'}
            ],
        }
      }   
    }
   
    },
    created () {
     this.loadSelectData();
     if(this.dataActivity!=null)
        {
        this.isShow=this.dataActivity.isShow;
        }
    },
    watch: {
        'model.sysactivityid':function (val) {
                if (val) {
                  this.selectPgList=[];
                  let selectparams = { keytype: "pgroup", parentid:val};   
                    getAction('/SelectData/SelectDataList', selectparams).then((res) => {
                      if (res.success) {
                        this.selectPgList= res.result.records;
                      }
                  }); 

                  this.selectVenueList=[];
              let selectVenueparams= { keytype: "activity_venue", parentid:val};  
                  getAction('/SelectData/SelectDataList', selectVenueparams).then((res) => {
                  if (res.success) {
                    this.selectVenueList= res.result.records;
                  }
                  }); 
                } 
                else {
                  this.selectPgList=[];
                  this.selectVenueList=[];
                }
              }
    },
    mounted(){
      },
    methods: {
      loadSelectData() { 
          this.selectActivityList=null;  
          let selectvenue= { keytype: "activity", parentid:"",curvalue:this.model.sysactivityid};  
           getAction('/SelectData/SelectDataList', selectvenue).then((res) => {
          if (res.success) {
            this.selectActivityList= res.result.records;
          }
      });  
      this.selectPgList=null;  
          let selectparams= { keytype: "pgroup", parentid:this.model.sysactivityid,curvalue:this.model.syspgid};  
           getAction('/SelectData/SelectDataList', selectparams).then((res) => {
          if (res.success) {
            this.selectPgList= res.result.records;
          }
      });  
      // this.selectVenueList=null;
      // let selectVenueparams= { keytype: "activity_venue", parentid:this.model.sysactivityid,curvalue:this.model.sysvenueid};  
      //      getAction('/SelectData/SelectDataList', selectVenueparams).then((res) => {
      //     if (res.success) {
      //       this.selectVenueList= res.result.records;
      //     }
      // }); 
   
        // console.log('this.dataActivity===>',this.dataActivity)
      },
      handChangeActivity(val)
        {
          this.$set( this.model, 'syspgidlist', '');
          this.$set( this.model, 'sysvenueid', '')
        },    
      add() {
        if(this.dataActivity!=null)
        {
         this.model.sysactivityid=this.dataActivity.sysactivityid;
         this.model.sysvenueid=this.dataActivity.sysvenueid;
         this.isShow=this.dataActivity.isShow
        }
        this.edit(this.modelDefault);
      },
      edit(record) {
        this.model = Object.assign({}, record);
        if(record!=null)
        {
          this.color=record.sgroupcolor;
        //  this.model.colors=record.sgroupcolor;
        }
        this.visible = true;
      },
   
      submitForm() {
        const that = this;   
        if(this.dataActivity!=null)
        {
        this.model.sysactivityid=this.dataActivity.sysactivityid;
        this.model.sysvenueid=this.dataActivity.sysvenueid;
     
        }
        // 触发表单验证
        this.$refs.form.validate(valid => {
  
          if (valid) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if (!this.model.syssgid) {
              httpurl += this.url.add;
              method = 'post';
            } else {
              httpurl += this.url.edit;
              method = 'put';
            }
            httpAction(httpurl, this.model, method).then((res) => {
              if (res.success) {
                that.$message.success(res.message);
                that.$emit('ok');
              } else {
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }
  
        })
      },
      SelectColor(){
     if( this.isShowColor==true)  
     {
      this.isShowColor=false;
      this.buttonText="选择颜色";
     }
     else
     {
      this.isShowColor=true;

      this.buttonText="关闭";
     } 

      },
        colorValueChange1(val) {
            // 取颜色对象的十六进制值
            this.color = val.hex
            this.model.sgroupcolor=this.color;
            

        },
   

    }
  }
</script>

<style scoped>
.color {
    display: flex;
    flex-wrap: wrap;
    text-align: center;
    div {
        margin: 20px;
        font-size: 18px;
        font-weight: bold;
        border: 1px solid #eee;
        padding: 10px;
    }
}
</style>